export function slugify(text) {
  return (
    text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '_') // Replace spaces with -
      // eslint-disable-next-line
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      // eslint-disable-next-line
      .replace(/\-\-+/g, '_') // Replace multiple - with single -
      .replace(/^_+/, '') // Trim - from start of text
      .replace(/_+$/, '')
  ) // Trim - from end of text
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function get_dairy_season_start_year({ forWinterConsult = false } = {}) {
  if (forWinterConsult) {
    return new Date().getFullYear()
  }

  var today = new Date()

  if (today.getMonth() + 1 > 6) {
    //January is 0!
    return today.getFullYear()
  }
  return today.getFullYear() - 1
}

export function unslugify(string) {
  return string
    .split(/[-_]/)
    .map((word) => capitalize(word))
    .join(' ')
}

export function scrollToTop() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  })
}

export function getCurrentUser() {
  return JSON.parse(localStorage.getItem('user'))
}

export function getUserId() {
  return JSON.parse(localStorage.getItem('user')).id
}

export function prefixedField(fieldName, id, prefix) {
  return `${prefix || 'farm'}_${id}-${fieldName}`
}

export function handleResponse(error) {
  var response = error.response
  var data = response.data
  if (response.status === 400) {
    return Promise.reject(data['non_field_errors'][0])
  }

  if (response.status === 401 || response.status == 403) {
    // auto logout if 401 response returned from api
    // userService.logout();
    location.reload(true)
  }
  const errorMessage = (data && data.message) || response.statusText
  return Promise.reject(errorMessage)
}
